/**
 * @file.
 * Contain bonusConstants
 */
import CouponBonusMobileImage from 'common/assets/images/bonus/promocode-bonus-mobile-header-image.png';
import CouponBonusImage from 'common/assets/images/bonus/promocode-bonus-header-image.png';
import TradeCountBonusMobileImage from 'common/assets/images/bonus/trades-count-bonus-mobile-header-image.png';
import TradeCountBonusImage from 'common/assets/images/bonus/trades-count-bonus-header-image.png';
import VolumeBonusMobileImage from 'common/assets/images/bonus/volume-bonus-mobile-header-image.png';
import VolumeBonusImage from 'common/assets/images/bonus/volume-bonus-header-image.png';
import WelcomeBonusMobileImage from 'common/assets/images/bonus/welcome-bonus-mobile-header-image.png';
import WelcomeBonusImage from 'common/assets/images/bonus/welcome-bonus-header-image.png';
import { BONUS_NAME_TO_TYPE } from 'common/utils/bonus.util';

/**
 * Availbable bonus list.
 */
export const AVAILABLE_BONUSES = [
  BONUS_NAME_TO_TYPE.Welcome,
  BONUS_NAME_TO_TYPE.TradesCount,
  BONUS_NAME_TO_TYPE.Volume,
  BONUS_NAME_TO_TYPE.Coupon,
];

/**
 * List header images for bonus.
 */
export const bonusBgImages = {
  [BONUS_NAME_TO_TYPE.Welcome]: {
    desktop: WelcomeBonusImage,
    mobile: WelcomeBonusMobileImage,
  },
  [BONUS_NAME_TO_TYPE.Volume]: {
    desktop: VolumeBonusImage,
    mobile: VolumeBonusMobileImage,
  },
  [BONUS_NAME_TO_TYPE.Coupon]: {
    desktop: CouponBonusImage,
    mobile: CouponBonusMobileImage,
  },
  [BONUS_NAME_TO_TYPE.TradesCount]: {
    desktop: TradeCountBonusImage,
    mobile: TradeCountBonusMobileImage,
  },
  getBonusImage: (bonusID, type) =>
    bonusBgImages?.[bonusID]?.[type] ||
    bonusBgImages['0f64284c-fa10-4813-ac2c-45303b16a536'][type],
};

/**
 * Bonus tag colors.
 */
export const BONUS_GUID_TAG_COLORS = {
  [BONUS_NAME_TO_TYPE.Welcome]: {
    color: '#2F80ED',
    bgColor: 'rgba(47, 128, 237, 0.3)',
  },
  [BONUS_NAME_TO_TYPE.TradesCount]: {
    color: '#2EBFDF',
    bgColor: 'rgba(46, 191, 223, 0.2);',
  },
  [BONUS_NAME_TO_TYPE.Volume]: {
    color: '#5237F9',
    bgColor: 'rgba(168, 170, 223, 0.2)',
  },
  [BONUS_NAME_TO_TYPE.Coupon]: {
    color: '#9247E9',
    bgColor: 'rgba(79, 220, 223, 0.2)',
  },
};

export const DISONA_WELCOME_BONUS = '386f21da-b985-494c-91fb-6de751ca7cdd';
